import { render, staticRenderFns } from "./Detalles_Components.vue?vue&type=template&id=7629f242&"
import script from "./Detalles_Components.vue?vue&type=script&lang=js&"
export * from "./Detalles_Components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports